import React, { useEffect, useState } from "react";
import { Plane } from "lucide-react";

export default function Loader() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 900);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="site-loader"
      className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center transition-opacity duration-500"
      style={{ opacity: visible ? 1 : 0 }}
    >
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 rounded-full border-2 border-[#0B3D91]/10" />
        <div className="absolute inset-0 rounded-full border-2 border-t-[#F9B233] border-r-transparent border-b-transparent border-l-transparent animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center">
          <Plane className="w-8 h-8 text-[#0B3D91] plane-loader" />
        </div>
      </div>
      <p className="mt-6 text-[#0B3D91] font-semibold tracking-widest text-sm uppercase">Malviya Travel</p>
    </div>
  );
}
